import React from 'react';
import { Shield } from 'lucide-react';

const LimitedCapacity = () => {
  return (
    <section id="limited-capacity" className="section-padding bg-white">
      <div className="container-center">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Icon */}
          <div className="w-20 h-20 bg-burnt-orange/20 rounded-full flex items-center justify-center mx-auto">
            <Shield className="h-10 w-10 text-burnt-orange" />
          </div>

          {/* Header */}
          <div className="space-y-6">
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
              We keep it small on purpose.
            </h2>
            
            <div className="space-y-6 max-w-3xl mx-auto">
              <p className="text-xl text-olive-brown/80 leading-relaxed">
                We work with a limited number of clients at a time to keep the quality high.
              </p>
              <p className="text-lg text-olive-brown/70 leading-relaxed">
                If you want reliable support (not random outsourcing), you're in the right place.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="pt-8">
            <a
              href="#contact"
              className="btn-primary"
              aria-label="Check availability for FractionalVa support"
            >
              Check Availability
            </a>
            <p className="text-sm text-olive-brown/60 mt-6">
              If a slot isn't open, we'll offer a waitlist option.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LimitedCapacity;